import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { ClientContract } from 'src/app/shared/models/clients/clientContract';

@Component({
  selector: 'app-print-client-contracts',
  templateUrl: './print-client-contracts.component.html',
  styleUrls: ['./print-client-contracts.component.scss']
})
export class PrintClientContractsComponent implements OnInit {
  contracts: ClientContract[] = [];
  clientName: string;

  constructor(
    private printService: PrintService,
  ) {
    this.contracts = this.printService.data.contracts;
    this.clientName = this.printService.data.clientName;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Client Contracts');
  }

}
